import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CrudModeOptions } from "../../products/objects/productState";
import { InsuranceSinister, SinisterWarranty } from "../objects/insurance-sinister";
import { SinisterState } from "../objects/sinister-state";
import { WarrantyMotif } from "../objects/warranty-motif";

const initialState: SinisterState = {
    selected_sinister: null,
    sinister_list: [],
    sinister_mode: null,
    sinister_search: null,
    selected_warranty: null,
    selected_motif: null,
    warranty_list: [],
    motif_list: [],
    all_motifs: [],
    warranty_mode: null,
    warranty_search: null,
};

export const sinister = createSlice({
    name: 'sinister',
    initialState,
    reducers: {
        setSelectedSinister: (state: SinisterState, action: PayloadAction<InsuranceSinister | null>): SinisterState => ({
            ...state, selected_sinister: action.payload
        }),
        setSinisterList: (state: SinisterState, action: PayloadAction<InsuranceSinister[]>): SinisterState => ({
            ...state, sinister_list: action.payload
        }),
        setSinisterMode: (state: SinisterState, action: PayloadAction<CrudModeOptions>): SinisterState => ({
            ...state, sinister_mode: action.payload
        }),
        setSinisterSearch: (state: SinisterState, action: PayloadAction<string | null>): SinisterState => ({
            ...state, sinister_search: action.payload
        }),
        setSelectedWarranty: (state: SinisterState, action: PayloadAction<SinisterWarranty | null>): SinisterState => ({
            ...state, selected_warranty: action.payload
        }),
        setSelectedMotif: (state: SinisterState, action: PayloadAction<WarrantyMotif | null>): SinisterState => ({
            ...state, selected_motif: action.payload
        }),
        setWarrantyList: (state: SinisterState, action: PayloadAction<SinisterWarranty[]>): SinisterState => ({
            ...state, warranty_list: action.payload
        }),
        setMotifList: (state: SinisterState, action: PayloadAction<WarrantyMotif[]>): SinisterState => ({
            ...state, motif_list: action.payload
        }),
        setAllMotifs: (state: SinisterState, action: PayloadAction<WarrantyMotif[]>): SinisterState => ({
            ...state, all_motifs: action.payload
        }),
        setWarrantyMode: (state: SinisterState, action: PayloadAction<CrudModeOptions>): SinisterState => ({
            ...state, warranty_mode: action.payload
        }),
        setWarrantySearch: (state: SinisterState, action: PayloadAction<string | null>): SinisterState => ({
            ...state, warranty_search: action.payload
        })
    }
});

export const {
    setSelectedSinister,
    setSelectedMotif,
    setSinisterMode,
    setSinisterSearch,
    setSinisterList,
    setWarrantyList,
    setWarrantyMode,
    setWarrantySearch,
    setSelectedWarranty,
    setMotifList,
    setAllMotifs
} = sinister.actions;